<template>
  <div id="SupplementOrder">
    <el-row>
      <el-col :xl="4" :lg="4" :md="6">
        <span>日期：{{ CURRENTDATE }}</span>
      </el-col>
      <el-col :xl="4" :lg="6" :md="6">
        <span>团餐公司：{{ firstForm.AB_NAME }}</span>
      </el-col>
      <el-col :xl="4" :lg="6" :md="6">
        <span>项目点：{{ firstForm.PROJECT_NAME }}</span>
      </el-col>
      <el-col :xl="4" :lg="6" :md="6">
        <span>档口名称：{{ firstForm.DK_NAME }}</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-form :inline="true" class="demo-form-inline" style="margin: 0;" :model="secondForm" :ref="secondForm" @submit.native.prevent>
        <el-col :xl="8" :lg="8" :md="10">
          <el-form-item label="产品名称：">
            <el-autocomplete size="medium" class="inline-input" v-model="secondForm.productName" :fetch-suggestions="querySearch"
              placeholder="请输入产品名称" :trigger-on-focus="false" @select="handleSelect" clearable></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row style="margin:20px 0">
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%" show-summary :summary-method="getSummaries">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="商品编码" min-width="50"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="商品名称" min-width="50"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" width="50"></el-table-column>
          <el-table-column prop="COUNT" label="数量" min-width="45">
            <template slot-scope="scope">
              <el-row>
                <el-col :xl="16" :lg="16" :md="20">
                  <el-input v-model="scope.row.COUNT" @focus="getCloumRow(scope.row)" @change="getCloumCount"></el-input>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="SUPPLIER_PRICE" label="单价" min-width="45"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="总价" min-width="45"></el-table-column>
          <el-table-column prop="PRODUCT_COMMON" label="备注" min-width="45">
            <template slot-scope="scope1">
              <el-row>
                <el-col>
                  <el-input v-model="scope1.row.PRODUCT_COMMON"></el-input>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="height:100px">
      <el-col :xl="{ span: 1, offset: 22 }" :lg="{ span: 1, offset: 22 }" :md="{ span: 1, offset: 22 }">
        <el-button @click="__infornationSure()" :disabled="isEmpty">确定</el-button>
      </el-col>
    </el-row>
    <el-dialog title="补单" center :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="false">
      <el-form :ref="firstForm" :model="firstForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="团餐公司：" required style="width: 95%">
          <el-select filterable v-model="firstForm.tc_name" placeholder="请选择" @change="getTCName" style="display:inline">
            <el-option v-for="item in tcName" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点" required style="width: 95%">
          <el-select filterable v-model="firstForm.PROJECT" placeholder="请选择项目点" @change="getProjectName" style="display:inline">
            <el-option v-for="item in projects" :key="item.PROJECT_ID" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口名称" required style="width: 95%">
          <el-select filterable v-model="firstForm.DK" placeholder="请选择档口" @change="getDkName" style="display:inline">
            <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-right: 13px" @click="cancel()">取消</el-button>
        <el-button style="margin-right:5%" @click="firstSure()">下一步</el-button>
      </span>
    </el-dialog>
    <el-dialog title="商品信息" :visible.sync="thirdFormVisible" width="30%">
      <el-form :ref="thirdForm" :model="thirdForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="名称：">{{ this.PRODUCT_NAME }}</el-form-item>
        <el-form-item label="单位：">{{ this.TYPE_UNIT }}</el-form-item>
        <el-form-item label="数量：">
          <el-input placeholder="请输入数量" v-model="thirdForm.COUNT" @change="getCount" clearable></el-input>
        </el-form-item>
        <el-form-item label="单价：">{{
          thirdForm.SUPPLIER_PRICE
        }}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addProduct(thirdForm)">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { haveDSXMDFun } from 'api/sellOrder';
import { tcName } from 'api/tcBanlance';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      projects: [],
      companyLists: [],
      dialogVisible: true,
      firstForm: {},
      dkList: [],
      secondForm: {},
      PRODUCT_NAME: '',
      TYPE_UNIT: '',
      thirdFormVisible: false,
      thirdForm: {},
      currentRow: {},
      tcName: [],
    };
  },
  methods: {
    // 获取团餐公司信息列表
    queryTCName() {
      tcName()
        .then((result) => {
          if (result[0].length !== 0) {
            this.tcName = result[0].company;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 获取项目点信息列表
    queryProject() {
      const params = {
        TC_ID: this.firstForm.tc_name,
      };
      haveDSXMDFun(params)
        .then((result) => {
          this.projects = result.length > 0 ? result[0].project : [];
          this.companyLists = result.length > 0 ? result[0].company : [];
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 获取档口信息列表
    querySupplier() {
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.firstForm.PROJECT) {
        params.PROJECT_ID = this.firstForm.PROJECT;
      } else {
        this.dkList = [];
        return false;
      }
      http
        .post(params)
        .then((result) => {
          this.dkList = result;
        })
        .catch((err) => {
          this.$message.show({
            text: err,
            type: 'error',
          });
        });
    },
    // 获取团餐公司名称
    getTCName(ID) {
      let obj = {};
      obj = this.tcName.find((item) => item.ID === ID);
      this.firstForm.AB_NAME = obj.AB_NAME;
      this.queryProject();
    },
    // 获取项目点的名称
    getProjectName(ID) {
      let obj = {};
      obj = this.projects.find((item) => item.PROJECT_ID === ID);
      this.firstForm.PROJECT_NAME = obj.PROJECT_NAME;
      this.querySupplier();
    },
    // 获取档口的名称
    getDkName(ID) {
      let obj = {};
      obj = this.dkList.find((item) => item.ID === ID);
      this.firstForm.DK_NAME = obj.NAME;
    },
    firstSure() {
      if ('DK_NAME' in this.firstForm && 'PROJECT_NAME' in this.firstForm) {
        this.dialogVisible = false;
      }
    },
    querySearch(queryString, callback) {
      this.$_getSearchRushOrderList1(queryString).then((res) => {
        const tmpArr = res.map((item) => ({
          BEFORE_TAX_PRICE: item.BEFORE_TAX_PRICE,
          PRODUCT_CODE: item.PRODUCT_CODE,
          PRODUCT_NAME: item.PRODUCT_NAME,
          PROJECT_PRICE: item.PROJECT_PRICE,
          SUPPLIER_PRICE: item.SUPPLIER_PRICE,
          TYPE_UNIT: item.TYPE_UNIT,
        }));
        const results = tmpArr.map((item) => {
          item.value = `${item.PRODUCT_NAME}(${item.TYPE_UNIT})`;
          return item;
        });
        callback(results);
      });
    },
    $_getSearchRushOrderList1() {
      const data = {
        SERVICE_ID: '10004',
        OTYPE: 34,
        PROJECT_ID: this.firstForm.PROJECT,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_NAME: this.secondForm.productName,
        DK_ID: this.firstForm.DK,
      };
      return new Promise((resolve, reject) => {
        http.post(data).then((res) => {
          resolve(res);
        });
      });
    },
    handleSelect(item) {
      this.PRODUCT_NAME = item.PRODUCT_NAME;
      this.TYPE_UNIT = item.TYPE_UNIT;
      this.thirdFormVisible = true;
      this.thirdForm = { ...item };
    },
    getCount(e) {
      this.thirdForm.COUNT = Number(e);
    },
    addProduct(row) {
      const snapItem = Object.assign(this.thirdForm, {
        TOTAL_FEE: Math.round(Number(this.thirdForm.COUNT) * Number(this.thirdForm.SUPPLIER_PRICE) * 100) / 100,
        PRODUCT_COMMON: '',
      });
      this.tableData.push(JSON.parse(JSON.stringify(snapItem)));
      this.thirdFormVisible = !this.thirdFormVisible;
      this.secondForm.productName = '';
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        if (
          index === 1 || index === 2 || index === 3 || index === 4 || index === 5 || index === 7) {
          return;
        }
        const values = data.map((item) => Number(item[column.property])); // 总价列的数组
        if (!values.every((value) => Number.isNaN(value))) {
          // 判断当前列有无NaN  ，有则直接这一列合计为 '--'
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr); // 防止是字符串累加
            if (!Number.isNaN(value)) {
              return prev + value;
            }
            return prev;
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '--';
        }
      });
      return sums;
    },
    // 聚焦获取行数据
    getCloumRow(row) {
      this.currentRow = { ...row };
    },
    // 获取修改后的数量
    getCloumCount(count) {
      this.tableData = this.tableData.map((item) => {
        if (item.PRODUCT_CODE === this.currentRow.PRODUCT_CODE) {
          item.COUNT = Number(count);
          item.TOTAL_FEE = Math.round(Number(item.COUNT) * Number(item.SUPPLIER_PRICE) * 100)
            / 100;
        }
        return item;
      });
    },
    __infornationSure() {
      const RPODUCT_ARRAY = this.tableData.map((item) => ({
        INNER_CODE: item.PRODUCT_CODE,
        COUNT: item.COUNT,
        BEFORE_TAX_PRICE: item.BEFORE_TAX_PRICE,
        PROJECT_PRICE: item.PROJECT_PRICE,
        SUPPLIER_PRICE: item.SUPPLIER_PRICE,
        PRODUCT_COMMENT: item.PRODUCT_COMMON,
      }));
      const judge = RPODUCT_ARRAY.every((item, index, array) => typeof item.COUNT === 'number' && item.COUNT >= 0);
      if (judge) {
        const data = {
          SERVICE_ID: '10004',
          OTYPE: 33,
          PROJECT_ID: this.firstForm.PROJECT,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          DK_ID: this.firstForm.DK,
          RPODUCT_ARRAY,
          SEND_DAY: this.CURRENTDATE,
        };
        http
          .post(data)
          .then((res) => {
            this.$message.show({ text: '确认成功', type: 'success' });
            this.tableData = [];
            this.$router.push('/OrderConfirmList');
          })
          .catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }
    },
    // 首页模态框点击取消触发
    cancel() {
      this.$router.back();
    },
  },
  computed: {
    CURRENTDATE() {
      return this.$store.state.CURRENT_DATE;
    },
    isEmpty() {
      return this.tableData.length === 0;
    },
  },
  created() {
    this.queryTCName();
    // this.queryProject();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/SupplementOrder.vue